(ns common.resource.query.product-selector
  (:require [cljs-bean.core :refer [->clj ->js]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn- sort->query-param [{:keys [field sort]}]
  (if (and field sort)
    (str (when (= sort "desc")
           "-")
         (name field))
    ""))

(defn product-selectors-query [{:keys [advertiser-id term page-size sort]}]
  (let [sort-query-param (sort->query-param sort)]
    #js {:queryKey #js ["product-selectors" advertiser-id term page-size sort-query-param]
         :queryFn (fn [^js ctx]
                    (qhttp/get (qhttp/render :api/product-selectors {:advertiser-id advertiser-id}
                                             {:limit page-size
                                              :offset (* page-size (dec (.-pageParam ctx)))
                                              :name term
                                              :sort sort-query-param})))
         :initialPageParam 1
         :getNextPageParam (fn [_ pages]
                             (inc (count pages)))
         :enabled (boolean advertiser-id)}))

(defn product-selector-query [{:keys [advertiser-id product-selector-id disabled]}]
  #js {:queryKey #js ["product-selector" advertiser-id product-selector-id]
       :queryFn (fn []
                  (qhttp/get (qhttp/render :api/product-selector {:advertiser-id advertiser-id
                                                                  :product-selector-id product-selector-id})))
       :enabled (and (boolean product-selector-id) (not disabled))})

(defn product-selector-result-query [{:keys [advertiser-id product-selector-id]}]
  #js {:queryKey #js ["product-selector-result" advertiser-id product-selector-id]
       :queryFn (fn []
                  (qhttp/get (qhttp/render :api/product-selector-result
                                           {:advertiser-id advertiser-id
                                            :product-selector-id product-selector-id})))
       :enabled (and (some? advertiser-id) (some? product-selector-id))})

(defn product-selector-preview-query [{:keys [advertiser-id product-selector]}]
  #js {:queryKey #js ["product-selector-preview" advertiser-id (->js product-selector)]
       :queryFn (fn []
                  (qhttp/post (qhttp/render :api/product-selector-preview {:advertiser-id advertiser-id})
                              {:body product-selector}))
       :enabled (and (some? advertiser-id) (map? product-selector))})

(defn create-product-selector-mutation
  [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["create-product-selector" advertiser-id]
       :mutationFn (fn [payload]
                     (rf/dispatch [:loader/open])
                     (qhttp/post (qhttp/render :api/product-selectors {:advertiser-id advertiser-id})
                                 {:body payload}))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    ;; We need to wait a bit otherwise the resource is not updated yet
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["product-selectors" advertiser-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Product Selector"
                                      :type :success
                                      :message "Successfully created product selector"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Product Selector"
                                 :type :error
                                 :message "Failed to create product selector"
                                 :response (->clj response)}]))})

(defn patch-product-selector-mutation
  [{:keys [advertiser-id product-selector-id]}]
  #js {:mutationKey #js ["patch-product-selector-mutation" advertiser-id product-selector-id]
       :mutationFn (fn [payload]
                     (rf/dispatch [:loader/open])
                     (qhttp/patch (qhttp/render :api/product-selector {:advertiser-id advertiser-id
                                                                       :product-selector-id product-selector-id})
                                  {:body payload}))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    ;; We need to wait a bit otherwise the resource is not updated yet
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["product-selectors" advertiser-id]})
                       (invalidate-queries {:queryKey ["product-selector" advertiser-id product-selector-id]})
                       (invalidate-queries {:queryKey ["product-selector-result" advertiser-id product-selector-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Product Selector"
                                      :type :success
                                      :message "Successfully saved product selector"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Product Selector"
                                 :type :error
                                 :message "Failed to save product selector"
                                 :response (->clj response)}]))})

(defn duplicate-product-selector-mutation
  [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["duplicate-product-selector" advertiser-id]
       :mutationFn (fn [{:keys [id] :as payload}]
                     (rf/dispatch [:loader/open])
                     (qhttp/post (qhttp/render :api/product-selector-duplicate {:advertiser-id advertiser-id
                                                                                :product-selector-id id})
                                 {:body (dissoc payload :id)}))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    ;; We need to wait a bit otherwise the resource is not updated yet
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["product-selectors" advertiser-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Product Selector"
                                      :type :success
                                      :message "Successfully created product selector"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Product Selector"
                                 :type :error
                                 :message "Failed to create product selector"
                                 :response (->clj response)}]))})

(defn delete-product-selector-mutation
  [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["delete-product-selector" advertiser-id]
       :mutationFn (fn [{:keys [id]}]
                     (rf/dispatch [:loader/open])
                     (qhttp/delete (qhttp/render :api/product-selector {:advertiser-id advertiser-id
                                                                        :product-selector-id id})))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    ;; We need to wait a bit otherwise the resource is not updated yet
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["product-selectors" advertiser-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Product Selector"
                                      :type :success
                                      :message "Successfully deleted product selector"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Product Selector"
                                 :type :error
                                 :message "Failed to delete product selector"
                                 :response (->clj response)}]))})
